global.site_name = "puppy";
